import { schema } from 'normalizr';

import { processUserCoverImage } from '../strategies/userCoverImage';

export const userCoverImageSchema: schema.Entity = new schema.Entity(
  'userCoverImages',
  {},
  { processStrategy: processUserCoverImage }
);

export type UserCoverImageEdgesSchema = typeof userCoverImageEdgesSchema;
export const userCoverImageEdgesSchema: schema.Object[] = [new schema.Object({ node: userCoverImageSchema })];
